"use client";

import NextLink from "next/link.js";
import type { AnchorHTMLAttributes } from "react";

type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  readonly href: string;
};

const NextLinkComponent = NextLink.default;

export const Link = ({ href, ...props }: LinkProps) => (
  <NextLinkComponent href={href} {...props} />
);
